// src/AdminDashboard.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import axios from 'axios'; // (Import axios)
import toast from 'react-hot-toast'; // (Import toast)

const API_URL = 'https://rys-backend.onrender.com/api';

// --- (เพิ่ม) Component ย่อยสำหรับ KPI Card ---
const KpiCard = ({ title, value, color }) => {
  const colors = {
    blue: 'from-blue-500 to-blue-600',
    green: 'from-green-500 to-green-600',
    yellow: 'from-yellow-400 to-yellow-500',
    purple: 'from-purple-500 to-purple-600',
    red: 'from-red-500 to-red-600',
    orange: 'from-orange-500 to-orange-600',
    amber: 'from-amber-500 to-amber-600',
    emerald: 'from-emerald-500 to-emerald-600',
    violet: 'from-violet-500 to-violet-600',
    pink: 'from-pink-500 to-pink-600',
    rose: 'from-rose-500 to-rose-600',
    lime: 'from-lime-500 to-lime-600',
  };
  return (
    <div className={`bg-gradient-to-br ${colors[color]} text-white p-6 rounded-lg shadow-lg`}>
      <h3 className="text-base font-medium uppercase tracking-wide">{title}</h3>
      <p className="text-5xl font-bold mt-2">{value}</p>
    </div>
  );
};

// --- (ไอคอนสำหรับปุ่ม) ---
const DocIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
  </svg>
);
const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
  </svg>

);
const MegaphoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5" />
  </svg>
);

const StarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
  </svg>
);
const RssIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-4" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M12.75 19.5v-.75a7.5 7.5 0 0 0-7.5-7.5H4.5m0-6.75h.75c7.87 0 14.25 6.38 14.25 14.25v.75M6 18.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
  </svg>
);
// ------------------------------------------

function AdminDashboard() {
  const navigate = useNavigate();
  const { user, getAuthHeaders } = useAuth();
  
  // (เพิ่ม) State สำหรับเก็บสถิติ
  const [stats, setStats] = useState(null);

  // (เพิ่ม) ดึงข้อมูลสถิติ
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${API_URL}/admin/stats`, getAuthHeaders());
        setStats(response.data);
      } catch (err) {
        toast.error("ไม่สามารถโหลดข้อมูลสรุปได้");
      }
    };
    
    if (user?.role === 'admin') {
      fetchStats();
    }
  }, [user, getAuthHeaders]); // (รันเมื่อ user โหลดเสร็จ)

  if (user?.role !== 'admin') {
    navigate('/');
    return null;
  }

  return (
    <div className=" p-4 sm:p-6 lg:p-8 flex-grow">
      <h2 className="text-3xl font-semibold text-gray-800 mb-6 border-b pb-3">
        Admin Panel (ศูนย์ควบคุม)
      </h2>
      
      {/* --- (เพิ่ม) ส่วนสรุป KPI --- */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <KpiCard title="เอกสารทั้งหมด" value={stats ? stats.total_documents : '...'} color="blue" />
        <KpiCard title="ประกาศ" value={stats ? stats.total_announcements : '...'} color="green" />
        <KpiCard title="หมวดหมู่" value={stats ? stats.total_categories : '...'} color="amber" />
        <KpiCard title="ผู้ใช้งาน" value={stats ? stats.total_users : '...'} color="red" />
      </div>

      <p className="text-2xl text-gray-600 mb-8">
        กรุณาเลือกเมนูที่ต้องการจัดการ
      </p>

      {/* --- เมนูแบบการ์ด (อัปเดตแล้ว) --- */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        
        {/* (ปรับ) การ์ดที่ 1: "จัดการคลังความรู้" */}
        <Link 
          to="/admin/documents" // (เปลี่ยน) ลิงก์ไปหน้า Hub ใหม่
          className="block p-8 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-blue-600 group-hover:text-blue-700">
            <DocIcon />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">
            จัดการคลังความรู้ (KB)
          </h3>
          <p className="text-base text-gray-600">
            (เพิ่มเอกสาร / จัดการหมวดหมู่ / Tags)
          </p>
        </Link>
        
        {/* 2. จัดการผู้ใช้ (เหมือนเดิม) */}
        <Link 
          to="/admin/users" 
          className="block p-8 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-purple-600 group-hover:text-purple-700">
            <UserIcon />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">
            จัดการผู้ใช้
          </h3>
          <p className="text-base text-gray-600">
            (เพิ่มพนักงาน / ลบ / รีเซ็ตรหัสผ่าน)
          </p>
        </Link>
        
        {/* 3. จัดการประกาศ (เหมือนเดิม) */}
        <Link 
          to="/admin/announcements" 
          className="block p-8 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-green-600 group-hover:text-green-700">
            <MegaphoneIcon />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">
            จัดการประกาศ
          </h3>
          <p className="text-base text-gray-600">
            (จัดการสไลด์โชว์ในหน้าแรก)
          </p>
        </Link>

        {/* --- (เพิ่ม 3) การ์ดใหม่ "จัดการไฟล์เด่น" --- */}
        <Link 
          to="/admin/featured" 
          className="block p-8 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-yellow-500 group-hover:text-yellow-600">
            <StarIcon />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">
            จัดการไฟล์เด่น
          </h3>
          <p className="text-base text-gray-600">
            (แก้ไข 3 ไฟล์ PDF อ้างอิง)
          </p>
        </Link>
        {/* -------------------------------------- */}
        <Link 
          to="/admin/feeds" 
          className="block p-8 bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow text-center group"
        >
          <div className="text-orange-500 group-hover:text-orange-600">
            <RssIcon />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-2">
            จัดการ Feed (Scraper)
          </h3>
          <p className="text-base text-gray-600">
            (เพิ่ม/ลบ URL กรมศุลฯ, สรรพากร)
          </p>
        </Link>

      </div>
    </div>
  );
}

export default AdminDashboard;